import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import ContactFormComponent from "../../components/contact/ContactFormComponent.tsx";
import ContactDecemberClosedDays from "../../components/contact/ContactDecemberClosedDays.tsx";
import {shouldShowWinterHolidayWarning} from "../../util/helpers.ts";
import ChatBotBoxComponent from "../../components/ChatBotBoxComponent.tsx";

export default function ContactFormPage() {
    setTitleAndMetaDescription("Kontakt - Kontaktformular")

    return (
        <>
            <section className="content content--wide">
                <div className="blurb">
                    <h1 className="heading heading--big">Kontaktformular</h1>
                    <p>
                        Her kan du indsende en besked til os, som vi vil vende tilbage på hurtigst muligt.
                    </p>
                    {shouldShowWinterHolidayWarning() && (
                        <ContactDecemberClosedDays/>
                    )}
                </div>

                <ContactFormComponent/>
            </section>

            <ChatBotBoxComponent/>
        </>
    )
}
